import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export default function Breadcrumbs({ items }) {
  return (
    <nav data-testid="breadcrumbs" aria-label="Breadcrumb" className="mb-5 flex flex-wrap items-center gap-1.5 text-[11px] font-medium text-gray-500">
      {items.map((it, i) => (
        <span key={i} className="flex items-center gap-1.5">
          {i > 0 && <ChevronRight size={12} className="text-gray-400" strokeWidth={1.5} />}
          {it.to ? (
            <Link data-testid={`breadcrumb-${i}-link`} to={it.to} className="transition-colors duration-150 hover:text-gray-950">{it.label}</Link>
          ) : (
            <span data-testid={`breadcrumb-${i}-current`} className="font-semibold text-gray-900">{it.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}
